<template>
  <div>
    <template v-if="$fetchState.pending">
      <PropertyRowSkeleton
        v-for="index in 2"
        :key="`PropertyRowSkeleton-${index}`"
      />
    </template>
    <template v-else>
      <template v-if="items.length">
        <PropertyRow
          v-for="item in items"
          :key="`PropertyRow_${item.id}`"
          :property="item"
          :href="item.url"
        />
      </template>
      <template v-else>
        <p class="pt-16 text-center">
          Al momento non ci sono tipologie disponibili per questa nuova
          costruzione.
        </p>
      </template>
    </template>
  </div>
</template>

<script>
import PropertyRow from '~/components/PropertyRow.vue'
import PropertyRowSkeleton from '~/components/PropertyRowSkeleton.vue'

export default {
  components: {
    PropertyRow,
    PropertyRowSkeleton,
  },
  props: {
    property: {
      type: Object,
      required: true,
    },
  },
  fetchOnServer: false,
  data() {
    return {
      items: [],
    }
  },
  async fetch() {
    try {
      const res = await this.$axios.get(
        `/_api/api/v2/constructions/${this.property.id}/units`
      )
      this.items = res.data.data
    } catch (e) {
      this.items = []
    }
  },
}
</script>
